/* This is the dummy DownloadManager for web, as Downloading Assets will not be supported on Browsers */

const createAssetDownloaderInstance = () => {
  return {
    state: {},
    downloadAssets: () => {},
    getLocalUri: () => {},
    hasFreeStorage: () => {},
    stopDownload: () => {},
  };
};
export default createAssetDownloaderInstance;
